import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const highlights1 = [
    "Prime Location in Wadala, A rapidly growing residential hub",
    "Premium 2 & 3 BHK Residences for spacious living",
    "Seamless Connectivity to Eastern Express Highway",
  ];
  const highlights2 = [
    "All Standard Amenities including Clubhouse, Gym & More",
    "Surrounded by Top Schools, Malls & Business Hubs",
    "Exclusive Gated Community for Premium Living Experience",
  ];
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      {/* <div class="theme-element timer-element">
        <picture>
          <img
            src="../images/timer-left-element.svg"
            width="100%"
            alt="Element"
          />
        </picture>
      </div> */}
      {/* <div class="theme-element timer-element-right">
        <picture>
          <img
            src="../images/timer-right-element.svg"
            width="100%"
            alt="Element"
          />
        </picture>
      </div> */}
      <div class="over1">
        <h1
          class="d-block section-heading color-primary text-capitalize"
          style={{ marginBottom: "1.25rem" }}
        >
          {project} - Project Overview
        </h1>
        <p>
          Rustomjee Wadala is a highly anticipated residential project in one of
          Mumbai’s most well-connected locales. Spread across 0.95 acres, this
          premium development offers spacious 2 & 3 BHK Homes, redefining luxury
          with modern interiors, exclusive amenities, and a prestigious
          lifestyle. Designed for those who value comfort, connectivity, and
          elegance, Rustomjee Wadala provides seamless access to business hubs,
          top educational institutions, and entertainment zones, making it the
          perfect investment in Mumbai’s real estate landscape.
          {/* <strong>
            Pre-Launch Booking Open – Secure Your Dream Home Today!
          </strong> */}
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Highlights of {project}
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
